/* eslint-disable arrow-body-style */
/* eslint-disable no-console */
import { CourseFindByName, UserAuthors, courseCategoryList, terminalList, CourseCreate } from './Request';

const mapCourses = courses => {
  if (!courses) return [];
  return courses.map(course => {
    return [
      course.name,
      course?.description,
      course?.Priority?.name,
      course?.CourseCategory.name,
      course?.User?.fullName,
      course?.User?.photo,
      course?.thumbnail,
      course?.updatedAt,
      !!course?.isDraft,
      course?.expirationDate,
      course?.id,
    ];
  });
};

const mapCourse = course => {
  if (!course) return [];
  return [
    course?.name,
    course?.description,
    course?.Priority?.name,
    course?.CourseCategory?.name,
    course?.User?.fullName,
    course?.User?.photo,
    course?.thumbnail,
    course?.updatedAt,
    course?.isDraft,
    course?.expirationDate,
    course?.id,
  ];
};

const mapGeneric = array => {
  if (!array) return [];
  return array.map(item => item.name || '');
};

const mapAuthors = authors => {
  if (!authors) return [];
  return authors.map(author => author?.fullName);
};

export const fetchCourses = async ({ category = null, name = '', author = null, terminal = null, isDraft = null }) => {
  const coursesObject = await CourseFindByName({
    category,
    name,
    author,
    terminal,
    isDraft,
  });

  const courses = mapCourses(coursesObject);

  return { courses };
};

export const fetchDropdownsInformation = async () => {
  const promises = [];
  promises.push(courseCategoryList());
  promises.push(UserAuthors());
  promises.push(terminalList());

  const data = await Promise.all(promises);

  const categories = mapGeneric(data[0]);
  const authors = mapAuthors(data[1]);
  const terminals = mapGeneric(data[2]);
  return { categories, authors, terminals };
};

export const createCourse = async course => {
  const newCourse = await CourseCreate(course);
  return mapCourse(newCourse);
};

export default { fetchCourses, fetchDropdownsInformation, createCourse };
